import { Link } from 'react-router-dom';

function getBreadcrumbs(pathname) {
  const baseUrl = 'https://oakandstoneremodel.com';
  const crumbs = [{ name: 'Home', url: baseUrl + '/' }];
  if (pathname === '/' || pathname === '') return crumbs;
  const segments = pathname.split('/').filter(Boolean);
  const mapping = {
    gallery: 'Gallery',
    process: 'Process',
    about: 'About',
    faqs: 'FAQs',
    careers: 'Careers',
    'service-area': 'Service Area',
    contact: 'Contact'
  };
  let url = baseUrl;
  segments.forEach((seg, i) => {
    url += '/' + seg;
    let name = mapping[seg] || seg.charAt(0).toUpperCase() + seg.slice(1);
    // Special case for /gallery/:subgallery
    if (segments[0] === 'gallery' && i === 1) {
      name = seg.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
    }
    crumbs.push({ name, url });
  });
  return crumbs;
}

export default function Breadcrumbs({ pathname }) {
  const crumbs = getBreadcrumbs(pathname);

  // Don't show breadcrumbs on home page
  if (pathname === '/') return null;

  // Add JSON-LD structured data for breadcrumbs
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: crumbs.map((c, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: c.name,
      item: c.url
    }))
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav
        aria-label="Breadcrumb"
        className="absolute bottom-0 left-0 z-20 py-4 w-full bg-gradient-to-t to-transparent from-black/40">
        <ol className="flex flex-wrap justify-center items-center space-x-2 text-sm">
          {crumbs.map((c, i) => (
            <li key={i} className="flex items-center text-white/90">
              {i > 0 && <span className="mx-2 text-white/60">/</span>}
              {i < crumbs.length - 1 ? (
                <Link
                  to={c.url.replace('https://oakandstoneremodel.com', '')}
                  className="transition-colors duration-200 hover:text-white">
                  {c.name}
                </Link>
              ) : (
                <span className="font-medium text-white">{c.name}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}
